import { useMemo } from 'react';

import type { ApprovalActor } from 'ui-product-approvals-common';
import { ACTOR } from '../constants/actors';
import { useAppTeams } from './useAppTeams';

export const useTeamMemberCounts = (
  approvers: ApprovalActor[]
): Record<string, number> => {
  const hasTeamApprovers = useMemo(
    () => approvers.some((approver) => approver.actor.actorType === ACTOR.TEAM),
    [approvers]
  );

  const { teamsRecord } = useAppTeams({ enabled: hasTeamApprovers });

  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(teamsRecord).map(([id, team]) => [
          id,
          new Set([...team.userIds, ...(team.secondaryUserIds ?? [])]).size,
        ])
      ),
    [teamsRecord]
  );
};
